import { Badge, Bleed, BlockStack, Box, Button, Card, Collapsible, Divider, Icon, IndexTable, InlineGrid, InlineStack, Link, Modal, Page, Text, Tooltip } from '@shopify/polaris'
import { ChevronDownMinor, ExternalSmallMinor } from '@shopify/polaris-icons'
import React, { useEffect, useState } from 'react'
import { InfoIcon, ShopifySquareIcon } from '../../../../../../Asests/svgIcon/icon'
import { DI, DIProps } from '../../../../../../Core'
import NewArchievedOrderItemTable from './NewArchievedOrderItemTable'
import { clickFooterButton } from '@shopify/app-bridge/actions/Modal'
import { t } from 'i18next'
import { getShopifyShopUrl } from '../../../Utils/Helper'

const NewArchievedorderPage = (props: DIProps) => {
    const [openCollspaible, setOpenCollapsible] = useState([false, false, false]);
    const [delayed, setDelayed] = useState(false);
    const [openModal, setOpenModal] = useState({
        open: false,
        data: []
    });
    const handleToggle = (ind: any) => {
        const newState = [...openCollspaible];
        newState[ind] = !newState[ind];
        setOpenCollapsible(newState);
    }
    const { location } = props;

    const [FullOrderData, setFullOrderData] = useState<any>({})

    useEffect(() => {
        let payload = {
            "order_id": location?.state?.id
        }
        props.di.POST("amazon/request/getArchiveOrderData", payload).then((data: any) => {
            if (data?.success) {
                setFullOrderData(data?.data)
            } else {
                props.error(data?.message ?? t("something went wrong"))
            }
        })
    }, [])

    useEffect(() => {
        const isOpen = openCollspaible.some(Boolean);
        if (isOpen) {
            setDelayed(true);
            return;
        }
        const timeout = setTimeout(() => {
            setDelayed(false);
        }, 500);
        return () => clearTimeout(timeout);
    }, [openCollspaible]);
    console.log(FullOrderData, "xdcfvgbhnjmk")


    function formatToReadableDate(isoString: string) {
        if (!isoString) return "N/A";

        const date = new Date(isoString);

        // Check for invalid date
        if (isNaN(date.getTime())) return "N/A";

        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }

    const [openSection, setOpenSection] = useState<{ type: string; index: number } | null>(null);

    const handleToggleCollapsable = (type: string, index: number) => {
        if (openSection?.type === type && openSection.index === index) {
            setOpenSection(null); // toggle off
        } else {
            setOpenSection({ type, index }); // toggle on
        }
    };
    return (
        <Page
            fullWidth={false}
            backAction={{ content: 'orderGrid', onAction: () => props.history('../allSales', { state: { "to": "archive-order" } }) }}
            title={props?.location?.state?.id}
            titleMetadata={
                <InlineStack gap={{ xs: '150', sm: '150', md: '200', lg: '600', xl: '600' }} align='center'>
                    {/* <InlineStack gap="200">
                        <Badge progress="partiallyComplete" tone="attention">Unshipped</Badge>
                        <Text as='p' variant="bodySm">Synced</Text>
                    </InlineStack> */}
                    <div className='Custom__Divider--Section'>
                        <InlineStack gap="200" blockAlign='center'>
                            <ShopifySquareIcon />


                            {FullOrderData?.targets?.[0]?.errors?.[0] ? <Tooltip content={FullOrderData?.targets?.[0]?.errors?.[0] ?? ""}>
                                <InlineStack gap={"200"}>
                                    <Badge tone="critical" icon={InfoIcon}>Error</Badge>
                                </InlineStack>
                            </Tooltip> : <Text as='span'>
                                <Link removeUnderline target='_blank' url={getShopifyShopUrl(FullOrderData?.targets?.[0]?.order_id, props)}>
                                    <InlineStack gap='100'>
                                        <Text as='span'>{FullOrderData?.targets?.[0]?.order_id}</Text>
                                        <Icon source={ExternalSmallMinor} tone="base" />
                                    </InlineStack>
                                </Link>
                            </Text>}
                        </InlineStack>
                    </div >
                </InlineStack >
            }
            subtitle={`${(formatToReadableDate(FullOrderData?.created_at))} from Amazon (via import)`}
            compactTitle
        >
            <BlockStack gap={"400"}>
                <NewArchievedOrderItemTable {...props} FullOrderData={FullOrderData} />
                <Card roundedAbove='sm'>
                    <BlockStack gap="300">
                        <Text variant="headingMd" as="h6">Ship To</Text>
                        <Bleed marginInline="500"><Divider /></Bleed>
                        <InlineGrid columns={{ xs: 2, sm: 2, md: 3, lg: 5, xl: 5 }} gap={"100"}>
                            <BlockStack gap={{ xs: '050', sm: '100', md: '200', lg: '200', xl: '200' }}>
                                <Text variant="headingSm" as="h6" fontWeight='medium'>Address line 1</Text>
                                <Text variant="headingSm" as="h6" fontWeight='medium' tone="subdued">{FullOrderData?.shipping_address?.address_line_1 || "N/A"}</Text>
                            </BlockStack>
                            <BlockStack gap={{ xs: '050', sm: '100', md: '200', lg: '200', xl: '200' }}>
                                <Text variant="headingSm" as="h6" fontWeight='medium'>City</Text>
                                <Text variant="headingSm" as="h6" fontWeight='medium' tone="subdued">{FullOrderData?.shipping_address?.city || "N/A"}</Text>
                            </BlockStack>
                            <BlockStack gap={{ xs: '050', sm: '100', md: '200', lg: '200', xl: '200' }}>
                                <Text variant="headingSm" as="h6" fontWeight='medium'>State</Text>
                                <Text variant="headingSm" as="h6" fontWeight='medium' tone="subdued">{FullOrderData?.shipping_address?.state || "N/A"}</Text>
                            </BlockStack>
                            <BlockStack gap={{ xs: '050', sm: '100', md: '200', lg: '200', xl: '200' }}>
                                <Text variant="headingSm" as="h6" fontWeight='medium'>Zipcode</Text>
                                <Text variant="headingSm" as="h6" fontWeight='medium' tone="subdued">{FullOrderData?.shipping_address?.zip_code || "N/A"}</Text>
                            </BlockStack>
                            <BlockStack gap={{ xs: '050', sm: '100', md: '200', lg: '200', xl: '200' }}>
                                <Text variant="headingSm" as="h6" fontWeight='medium'>Country</Text>
                                <Text variant="headingSm" as="h6" fontWeight='medium' tone="subdued">{FullOrderData?.shipping_address?.country || "N/A"}</Text>
                            </BlockStack>
                        </InlineGrid>
                    </BlockStack>
                </Card>
                <InlineGrid columns={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3 }} gap={"300"} alignItems={delayed ? "start" : undefined}>
                    {FullOrderData?.shipment && <Card roundedAbove='sm'>
                        <BlockStack gap="300">
                            <Text variant="headingMd" as="h6">Shipment</Text>
                            <Bleed marginInline="500"><Divider /></Bleed>
                            {FullOrderData?.shipment?.length > 1 ? <>
                                {FullOrderData?.shipment?.map((data: any, index: number) => {
                                    return (
                                        <Box key={index} padding={"200"} background='bg' borderWidth='050' borderColor='transparent' borderRadius='200'>
                                            <BlockStack gap={"200"}>
                                                <div onClick={() => handleToggleCollapsable("shipment", index)} className='c-pointer'>
                                                    <InlineStack align="space-between" blockAlign="center">
                                                        <Text variant="headingMd" as="h6">{`Id- ${(data?.['_id']?.['$oid'])}`}</Text>
                                                        <span> <Icon source={ChevronDownMinor} tone="base" /></span>
                                                    </InlineStack>
                                                </div>
                                                <Collapsible
                                                    open={openSection?.type === "shipment" && openSection.index === index}
                                                    id={`collapsible-${index}`}
                                                    transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
                                                    expandOnPrint
                                                >
                                                    <BlockStack gap={"200"}>
                                                        <InlineStack gap="400" align='space-between'>
                                                            <Text variant="bodyLg" as="p" fontWeight='regular'>Shipped on:</Text>
                                                            <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{formatToReadableDate(data?.['created_at'])}</Text>
                                                        </InlineStack>

                                                        <InlineStack gap="400" align='space-between'>
                                                            <Text variant="bodyLg" as="p" fontWeight='regular'>Tracking Company:</Text>
                                                            <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{data?.tracking?.company || 'N/A'}</Text>
                                                        </InlineStack>

                                                        <InlineStack gap="400" align='space-between'>
                                                            <Text variant="bodyLg" as="p" fontWeight='regular'>Tracking Number:</Text>
                                                            <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{data?.tracking?.number || 'N/A'}</Text>
                                                        </InlineStack>
                                                        <InlineStack gap="400" align='space-between'>
                                                            <Text variant="bodyLg" as="p" fontWeight='regular'>No. of items</Text>
                                                            <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{data?.items?.length || 'N/A'}</Text>
                                                        </InlineStack>
                                                        <InlineStack align='end'>
                                                            <Button size='slim' variant='plain' onClick={() => setOpenModal({
                                                                data: data?.items,
                                                                open: !openModal.open
                                                            })}>Show more details</Button>
                                                        </InlineStack>
                                                    </BlockStack>
                                                </Collapsible>
                                            </BlockStack>
                                        </Box>
                                    );
                                })}
                            </> : <BlockStack gap={"300"}>
                                <InlineStack gap="400" align='space-between'>
                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Shipped on:</Text>
                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{formatToReadableDate(FullOrderData?.shipment?.[0]?.['created_at'])}</Text>
                                </InlineStack>

                                <InlineStack gap="400" align='space-between'>
                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Tracking Company:</Text>
                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{FullOrderData?.shipment?.[0]?.['tracking']?.company || 'N/A'}</Text>
                                </InlineStack>

                                <InlineStack gap="400" align='space-between'>
                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Tracking Number:</Text>
                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{FullOrderData?.shipment?.[0]?.['tracking']?.number || 'N/A'}</Text>
                                </InlineStack>
                                <InlineStack gap="400" align='space-between'>
                                    <Text variant="bodyLg" as="p" fontWeight='regular'>No. of items</Text>
                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{FullOrderData?.shipment?.[0]?.items?.length || 'N/A'}</Text>
                                </InlineStack>
                                <InlineStack align='end'>
                                    <Button size='slim' variant='plain' onClick={() => setOpenModal({
                                        data: FullOrderData?.shipment?.[0]?.items,
                                        open: !openModal.open
                                    })}>Show more details</Button>
                                </InlineStack>
                            </BlockStack>}
                        </BlockStack>
                    </Card>}
                    {FullOrderData?.cancellation && <Card roundedAbove='sm'>
                        <BlockStack gap="300">
                            <Text variant="headingMd" as="h6">Cancellation</Text>
                            <Bleed marginInline="500"><Divider /></Bleed>
                            {
                                FullOrderData?.cancellation?.length > 1 ?
                                    <>
                                        {FullOrderData?.cancellation?.map((data: any, index: number) => {
                                            return (
                                                <Box key={index} padding={"200"} background='bg' borderWidth='050' borderColor='transparent' borderRadius='200'>
                                                    <BlockStack gap={"200"}>
                                                        <div onClick={() => handleToggleCollapsable("cancellation", index)} className='c-pointer'>
                                                            <InlineStack align="space-between" blockAlign="center">
                                                                <Text variant="headingMd" as="h6">{`Id- ${(data?.['_id']?.['$oid'])}`}</Text>
                                                                <span> <Icon source={ChevronDownMinor} tone="base" /></span>
                                                            </InlineStack>
                                                        </div>
                                                        <Collapsible
                                                            open={openSection?.type === "cancellation" && openSection.index === index}
                                                            id={`collapsible-${index}`}
                                                            transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
                                                            expandOnPrint
                                                        >
                                                            <BlockStack gap={"200"}>
                                                                <InlineStack gap="400" align='space-between'>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Cancelled id:</Text>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{data?.marketplace_reference_id || 'N/A'}</Text>
                                                                </InlineStack>
                                                                <InlineStack gap="400" align='space-between'>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Cancelled On::</Text>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{formatToReadableDate(data?.['created_at'] || "N/A")}</Text>
                                                                </InlineStack>



                                                                <InlineStack gap="400" align='space-between'>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Cancel reason:</Text>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{data?.cancel_reason || 'N/A'}</Text>
                                                                </InlineStack>
                                                                <InlineStack gap="400" align='space-between'>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular'>No. of items</Text>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{data?.items?.length || 'N/A'}</Text>
                                                                </InlineStack>
                                                                <InlineStack align='end'>
                                                                    <Button size='slim' variant='plain' onClick={() => setOpenModal({
                                                                        data: data?.items,
                                                                        open: !openModal.open
                                                                    })}>Show more details</Button>
                                                                </InlineStack>
                                                            </BlockStack>
                                                        </Collapsible>
                                                    </BlockStack>
                                                </Box>
                                            );
                                        })}
                                    </> :
                                    <>
                                        <InlineStack gap="400" align='space-between'>
                                            <Text variant="bodyLg" as="p" fontWeight='regular'>Cancelled item id:</Text>
                                            <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{FullOrderData?.cancellation?.[0]?.marketplace_reference_id}</Text>
                                        </InlineStack>
                                        <InlineStack gap="400" align='space-between'>
                                            <Text variant="bodyLg" as="p" fontWeight='regular'>Cancelled On:</Text>
                                            <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{formatToReadableDate(FullOrderData?.cancellation?.[0]?.['created_at'] || "N/A")}</Text>
                                        </InlineStack>

                                        <InlineStack gap="400" align='space-between'>
                                            <Text variant="bodyLg" as="p" fontWeight='regular'>Cancel reason:</Text>
                                            <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{FullOrderData?.cancellation?.[0]?.cancel_reason || "N/A"}</Text>
                                        </InlineStack>

                                        <InlineStack gap="400" align='space-between'>
                                            <Text variant="bodyLg" as="p" fontWeight='regular'>No. of items</Text>
                                            <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{FullOrderData?.cancellation?.[0]?.items?.length || 'N/A'}</Text>
                                        </InlineStack>
                                        <InlineStack align='end'>
                                            <Button size='slim' variant='plain' onClick={() => setOpenModal({
                                                data: FullOrderData?.cancellation?.[0]?.items,
                                                open: !openModal.open
                                            })}>Show more details</Button>
                                        </InlineStack>
                                    </>
                            }
                        </BlockStack>
                    </Card>}
                    {FullOrderData?.refund && <Card roundedAbove='sm'>
                        <BlockStack gap="300">
                            <Text variant="headingMd" as="h6">Refund</Text>
                            <Bleed marginInline="500"><Divider /></Bleed>
                            {
                                (FullOrderData?.refund?.length > 1) ? <>
                                    {
                                        FullOrderData?.refund?.map((data: any, index: number) => {
                                            return (
                                                <Box key={index} padding={"200"} background='bg' borderWidth='050' borderColor='transparent' borderRadius='200'>
                                                    <BlockStack gap={"200"}>
                                                        <div onClick={() => handleToggleCollapsable("refund", index)} className='c-pointer'>
                                                            <InlineStack align="space-between" blockAlign="center">
                                                                <Text variant="headingMd" as="h6">{`Id- ${(data?.['_id']?.['$oid'])}`}</Text>
                                                                <span> <Icon source={ChevronDownMinor} tone="base" /></span>
                                                            </InlineStack>
                                                        </div>
                                                        <Collapsible
                                                            open={openSection?.type === "refund" && openSection.index === index}
                                                            id={`collapsible-${index}`}
                                                            transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
                                                            expandOnPrint
                                                        >
                                                            <BlockStack gap={"200"}>
                                                                <InlineStack gap="400" align='space-between'>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Refund id:</Text>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{data?.marketplace_reference_id || 'N/A'}</Text>
                                                                </InlineStack>

                                                                <InlineStack gap="400" align='space-between'>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Refund On:</Text>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{formatToReadableDate(data?.created_at)}</Text>
                                                                </InlineStack>

                                                                <InlineStack gap="400" align='space-between'>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Refund Quantity:</Text>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{data?.items?.[0]?.qty || 'N/A'}</Text>
                                                                </InlineStack>
                                                                <InlineStack gap="400" align='space-between'>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular'>Refund Amount:</Text>
                                                                    <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{data?.refund_amount?.marketplace_price || 'N/A'}</Text>
                                                                </InlineStack>
                                                                <InlineStack align='end'>
                                                                    <Button size='slim' variant='plain' onClick={() => setOpenModal({
                                                                        data: data?.items,
                                                                        open: !openModal.open
                                                                    })}>Show more details</Button>
                                                                </InlineStack>
                                                            </BlockStack>
                                                        </Collapsible>
                                                    </BlockStack>
                                                </Box>
                                            )
                                        })
                                    }
                                </> : <>
                                    <InlineStack gap="400" align='space-between'>
                                        <Text variant="bodyLg" as="p" fontWeight='regular'>Refund item id:</Text>
                                        <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{FullOrderData?.refund?.[0]?.marketplace_reference_id || 'N/A'}</Text>
                                    </InlineStack>
                                    <InlineStack gap="400" align='space-between'>
                                        <Text variant="bodyLg" as="p" fontWeight='regular'>Refund On:</Text>
                                        <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{formatToReadableDate(FullOrderData?.refund?.[0]?.created_at)}</Text>
                                    </InlineStack>
                                    <InlineStack gap="400" align='space-between'>
                                        <Text variant="bodyLg" as="p" fontWeight='regular'>Refund Quantity:</Text>
                                        <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">{FullOrderData?.refund?.[0]?.items?.[0]?.qty || 'N/A'}</Text>
                                    </InlineStack>
                                    <InlineStack gap="400" align='space-between'>
                                        <Text variant="bodyLg" as="p" fontWeight='regular'>Refund Amount:</Text>
                                        <Text variant="bodyLg" as="p" fontWeight='regular' tone="subdued">${FullOrderData?.refund?.[0]?.refund_amount?.marketplace_price || 'N/A'}</Text>
                                    </InlineStack>
                                    <InlineStack align='end'>
                                        <Button size='slim' variant='plain' onClick={() => setOpenModal({
                                            data: FullOrderData?.refund?.[0]?.items,
                                            open: !openModal.open
                                        })}>Show more details</Button>
                                    </InlineStack></>
                            }

                        </BlockStack>
                    </Card>
                    }
                </InlineGrid>
            </BlockStack>
            <ArchievedDetailModal openModal={openModal} setOpenModal={setOpenModal} />
        </Page >
    )
}

export const ArchievedDetailModal = (props: any) => {
    const { openModal, setOpenModal } = props;

    return (
        <Modal
            title="More details"
            open={openModal?.open}
            onClose={() => setOpenModal({
                data: [],
                open: false
            })}
        >
            <Modal.Section>
                <Card padding={'0'}>
                    <IndexTable
                        resourceName={{ singular: 'product', plural: 'products' }}
                        itemCount={openModal?.data?.length}
                        selectable={false}
                        headings={[
                            { title: 'Title' },
                            { title: 'SKU' },
                            { title: 'Quantity' },
                            { title: 'Shipped Quantity' },
                        ]}
                    >
                        {openModal?.data.map((data: any, index: number) => (
                            <IndexTable.Row
                                id={data?.title}
                                key={data?.title}
                                position={index}
                            >
                                <IndexTable.Cell><Text as='p' variant="bodyMd" fontWeight="medium">{data?.title || "N/A"}</Text></IndexTable.Cell>
                                <IndexTable.Cell>{data?.sku || "N/A"}</IndexTable.Cell>
                                {/* <IndexTable.Cell>{(data?.price ?? data?.marketplace_price) || "N/A"}</IndexTable.Cell> */}
                                <IndexTable.Cell>{data?.qty || "N/A"}</IndexTable.Cell>
                                <IndexTable.Cell>{data?.shipped_qty || "N/A"}</IndexTable.Cell>
                            </IndexTable.Row>
                        ))}
                    </IndexTable>
                </Card>
            </Modal.Section>
        </Modal>
    );
}

export default DI(NewArchievedorderPage)
